// extracted by mini-css-extract-plugin
export default {"content":"InfoSeller_content__4SNRA","content_info":"InfoSeller_content_info__EOPtW"};